<template>
  <v-card
    class="mx-auto"
    style="
      box-shadow: 0 8px 32px rgb(47 60 74 / 1%), 0 8px 16px rgb(47 60 74 / 2%);
    "
    :class="{ 'pa-4': padding, cardClass }"
    :color="$vuetify.theme.dark && color == 'white' ? 'dark' : color"
    :dark="$vuetify.theme.dark"
    width="100%"
    max-width="100%"
    elevation="3"
    rounded="xl">
    <slot />
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import themeMixin from '@/mixin/themeMixin'
export default defineComponent({
  name: 'Card',

  props: {
    color: {
      type: String,
      default: 'white',
    },
    cardClass: {
      type: String,
      default: '',
    },

    padding: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [themeMixin],
})
</script>